export { default } from './useControlled';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useControlled/index.js
// module id = 377
// module chunks = 22